module.exports = __webpack_public_path__ + "img/东海渔场预报服务系统.fe2324cf.png";